export interface EmailTemplate {
  id: number | null;
  name: string;
  language: string;
  organization_id: number;
  kind: TemplateKind;
  default: boolean;
  updated_at: string;
  subject: string;
  expiry_days: number;
  in_use: boolean;
  editor_version: EditorVersion;
  source: boolean;
}

export enum EditorVersion {
  V1 = 'v1',
  V2 = 'v2',
}

export enum TemplateKind {
  CERTIFICATE_RECEIVED = 'certificate_received',
  BADGE_RECEIVED = 'badge_received',
  CERTIFICATE_AND_BADGE_RECEIVED = 'certificate_and_badge_received',
  CREDENTIAL_EXPIRY_WARNING = 'credential_expiry_warning',
  CREDENTIAL_EXPIRED = 'credential_expired',
  CREDENTIAL_RENEWED = 'credential_renewed',
}
